import { FundFamilySetupTabProps } from "features/fund-family/setup/FundFamilySetupTabProps";
import { WaterfallEditForm } from "features/waterfall/WaterfallEditForm";
import {
  useWaterfallConfigRetrieveSuspense,
  useWaterfallConfigUpsert,
} from "gen/endpoints/waterfall/waterfall";
import { WaterfallConfigData } from "gen/model/waterfallConfigData";
import { WaterfallConfigUpsertDataRequest } from "gen/model/waterfallConfigUpsertDataRequest";
import React, { useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const FundFamilySetupFundTabWaterfall: React.FC = () => {
  const { fundFamilyId, onCancel } =
    useOutletContext<FundFamilySetupTabProps>();

  const { data: waterfallData } = useWaterfallConfigRetrieveSuspense(
    fundFamilyId,
    undefined,
  );
  const { mutateAsync: upsertWaterfallConfig } = useWaterfallConfigUpsert();

  const saveWaterfallConfig = useCallback(
    async (data: WaterfallConfigData | WaterfallConfigUpsertDataRequest) => {
      await upsertWaterfallConfig({ fundFamilyId, data });
    },
    [upsertWaterfallConfig, fundFamilyId],
  );

  return (
    <PageTabBody>
      <WaterfallEditForm
        fundFamilyId={fundFamilyId}
        waterfallData={waterfallData}
        saveWaterfallConfig={saveWaterfallConfig}
        onCancel={onCancel}
      />
    </PageTabBody>
  );
};
